import React from 'react';
import { SettingsBreadcrumbs } from '../../../settingsModule';
import { Breadcrumb } from '../../../../shared/web/layout/Breadcrumbs';
import WebhookRequestsLogEntriesList from './WebhookRequestsLogEntriesList';
import { useParams } from 'react-router-dom';
import { useWebhookSubscriptionsService, WebhookSubscription } from 'nekst-api';
import { MassUpdate, Show, SimpleBlock, Text, TextField } from 'ui-builder';
import { useSubscriptionEventHelper } from '../subscriptionEventHelper';
import WebhookSubscriptionActionsButton from './WebhookSubscriptionActionsButton';
import { EventTypeField } from './EventTypeField';
import WebhookEnabledField from './WebhookEnabledField';

import styles from './WebhookInfo.module.scss';

function WebhookInfo() {
  return (
    <SimpleBlock className={styles.block}>
      <SimpleBlock>
        <Text bold>URL: </Text>
        <TextField source="webhookUrl" />
      </SimpleBlock>
      <SimpleBlock>
        <Text bold>Event: </Text>
        <EventTypeField />
      </SimpleBlock>
      <SimpleBlock>
        <Text bold>Status: </Text>
        <WebhookEnabledField />
      </SimpleBlock>
    </SimpleBlock>
  )
}


function WebhookRequestsLogPageImpl(props: {
  subscriptionId: number;
}) {

  const webhookSubscriptionsService = useWebhookSubscriptionsService();

  const typeHelper = useSubscriptionEventHelper();

  function trimTitleIfNeeded(title: string) {
    if (title.length > 40) {
      return title.substring(0, 35) + '...';
    } else {
      return title;
    }
  }

  return (
    <Show
      getDataFunc={webhookSubscriptionsService.getSubscriptionById}
      id={props.subscriptionId}
      title={(data) => trimTitleIfNeeded(`${typeHelper.getLabel(data.eventType)}: ${data.webhookUrl}`)}
      buttons={<WebhookSubscriptionActionsButton />}
    >
      <SettingsBreadcrumbs>
        <Breadcrumb text="Webhook Subscriptions" href="/settings/webhooks">
          <Breadcrumb<WebhookSubscription> text={(data) => `${typeHelper.getLabel(data.eventType)}: ${data.webhookUrl}`} />
        </Breadcrumb>
      </SettingsBreadcrumbs>
      <WebhookInfo />
      <MassUpdate enabled>
        <WebhookRequestsLogEntriesList subscriptionId={props.subscriptionId} />
      </MassUpdate>
    </Show>
  );

}

export default function WebhookRequestsLogPage() {

  const { id: subscriptionIdString } = useParams<{ id: string }>();

  if (subscriptionIdString) {
    const subscriptionId = parseInt(subscriptionIdString, 10);

    return (
      <WebhookRequestsLogPageImpl subscriptionId={subscriptionId} />
    );
  } else {
    return null;
  }
}
